export default "__VITE_ASSET__NDhPOjyM__"